var _g, _path, _g2, _g3, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinnedStateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 51,
    fill: "none",
    viewBox: "0 0 57 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M31.541 35.68c-3.941 1.7-8.02 2.582-11.34 2.45-3.32-.13-5.608-1.263-6.36-3.149-.754-1.885.09-4.369 2.344-6.904s5.734-4.914 9.676-6.614c3.941-1.7 8.02-2.58 11.34-2.45 3.32.131 5.607 1.264 6.36 3.15.754 1.885-.09 4.369-2.344 6.904s-5.735 4.914-9.676 6.614Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M48.877 19.95a13.085 13.085 0 0 1-.968 5 13.025 13.025 0 0 1-2.801 4.246 12.94 12.94 0 0 1-4.207 2.838 12.88 12.88 0 0 1-14.142-2.838 13.025 13.025 0 0 1-2.802-4.245 13.086 13.086 0 0 1-.968-5.001 13.09 13.09 0 0 1 .968-5.002 13.025 13.025 0 0 1 2.802-4.244 12.94 12.94 0 0 1 4.207-2.838 12.879 12.879 0 0 1 9.935 0 12.94 12.94 0 0 1 4.207 2.838 13.025 13.025 0 0 1 2.802 4.244c.646 1.587.975 3.287.967 5.002Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)",
    opacity: 0.303
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M34.58 28.479c-2.43 1.182-5.208 1.564-7.723 1.062-2.515-.502-4.561-1.846-5.689-3.737-1.128-1.892-1.244-4.175-.324-6.348.92-2.173 2.803-4.057 5.232-5.24 2.43-1.181 5.207-1.563 7.722-1.061 2.515.501 4.562 1.846 5.69 3.737 1.127 1.891 1.243 4.175.323 6.348-.92 2.172-2.802 4.057-5.232 5.239Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M45.595 17.3a8.073 8.073 0 0 1-2.326 5.704 7.985 7.985 0 0 1-2.595 1.75 7.947 7.947 0 0 1-8.725-1.75 8.073 8.073 0 0 1-2.326-5.704 8.072 8.072 0 0 1 2.326-5.705 7.984 7.984 0 0 1 2.595-1.75 7.946 7.946 0 0 1 8.725 1.75c.742.75 1.33 1.64 1.729 2.619.399.979.602 2.027.597 3.085Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "evenodd",
    d: "M28.863 28.297c-2.756-2.214-3.497-3.468-3.078-6.014 1.195 3.298 2.957 5.826 3.078 6.014Z",
    clipRule: "evenodd",
    opacity: 0.74
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M52.849 10.831a9.33 9.33 0 0 1-.678 3.563 8.518 8.518 0 0 1-1.962 2.92 8.167 8.167 0 0 1-2.947 1.827 8.461 8.461 0 0 1-3.479.456 9.245 9.245 0 0 1-3.479-.985 10.077 10.077 0 0 1-2.946-2.275 10.45 10.45 0 0 1-1.963-3.217 10.126 10.126 0 0 1-.677-3.666 9.333 9.333 0 0 1 .677-3.563 8.52 8.52 0 0 1 1.963-2.919 8.166 8.166 0 0 1 2.946-1.827 8.46 8.46 0 0 1 3.48-.457 9.246 9.246 0 0 1 3.478.985 10.08 10.08 0 0 1 2.947 2.275 10.45 10.45 0 0 1 1.962 3.217c.453 1.181.683 2.427.678 3.666Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillRule: "evenodd",
    d: "M45.878 1.863c4.39 2.938 5.648 4.609 5.317 8.014-2.177-4.399-5.114-7.764-5.317-8.014Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(83.586 1.89 31.818) scale(13.3315 20.3696)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.991
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopOpacity: 0.616
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(12.9441 0 0 13.0194 40.505 19.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.08661 12.85846 -12.42467 4.91501 33.1 19.774)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.991
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopOpacity: 0.616
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.98575 0 0 8.03228 37.61 17.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F0000",
    stopOpacity: 0.584
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#840000",
    stopOpacity: 0.498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.29712 .84561 -3.39427 -5.2066 26.1 25.419)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.83774 6.92008 -6.67638 6.59695 44.646 8.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D43500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#D42400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#D40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#950000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.84504 -1.13938 4.67205 7.56557 50.363 5.718)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 55.76,
    height: 44.644,
    x: 0.821,
    y: 6.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4986_49174",
    stdDeviation: 6.375
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 33.811,
    height: 30.432,
    x: 13.422,
    y: 6.132,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4986_49174",
    stdDeviation: 3.404
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 18.822,
    height: 18.991,
    x: 28.198,
    y: 7.804,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4986_49174",
    stdDeviation: 0.713
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnedStateIcon);
export default __webpack_public_path__ + "static/media/pinned-state-icon.2c00451598da32aa4c6191ac79c38cb7.svg";
export { ForwardRef as ReactComponent };